<div class="upload_group">
  <div class="upload_group_button">
    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" multiple
      accept="image/*,audio/*,video/*,.pdf,.txt,.zip,.rar,.doc,.docx,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      style="display:none;">
    <button type="button" [loading]="loadingUpload" mat-stroked-button color="primary" (click)="file.click()">
      <mat-icon>cloud_upload</mat-icon> {{title}}
    </button>
  </div>
  <div class="upload_group_message" *ngIf="progress > 0">
    <mtx-progress [value]="progress" [striped]="true" foreground="#169c05" background="#e0e0e0">
      {{progress}}%
    </mtx-progress>
    <!-- <span class="upload" *ngIf="progress > 0">
      {{progress}}%
    </span> 
    <span class="upload" *ngIf="message">
      {{message}}
    </span>-->
  </div>
</div>